export const documentDetailState = {
  documents: [],
  detailInfo: {
    adquirientes: [],
    compra_para: undefined,
    es_comprapara: undefined,
    factura: undefined,
    solicitud: undefined,
    vehiculo: undefined,
  },
  isLoading: false,
  isError: false,
  errorMessage: null,
};
